<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :width="width" :height="height"><g stroke-linecap="square" stroke-linejoin="miter" :stroke-width="stroke" :fill="_secondaryfill" :stroke="_secondaryfill"><line fill="none" stroke-miterlimit="10" x1="30" y1="16" x2="2" y2="16" /> <line fill="none" stroke-miterlimit="10" x1="30" y1="7" x2="2" y2="7" :stroke="fill" /> <line fill="none" stroke-miterlimit="10" x1="30" y1="25" x2="16" y2="25" :stroke="fill" /></g></svg>
</template>

<script>
	export default {
		props: {
			width: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			height: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			stroke: {
				type: Number,
				default: 1
			},
			fill: {
				type: String,
				default: 'currentColor'
			},
			secondaryfill: {
				type: String
			}
		},
		computed: {
			_secondaryfill() {
				return this.secondaryfill || this.fill;
			}
		}
	};
</script>